import { AppPathEnum } from '../enums/appPathEnum';
import type { CurrentUser } from './currentUser';

export function getMembershipRedirect(user: CurrentUser): AppPathEnum | undefined {
    if (user.isTransferOnboarding) return AppPathEnum.MEMBERSHIP_TRANSFER;
    if (user.isAffiliateOnboarding) return AppPathEnum.AFFILIATE_ASSOCIATE;
    if (user.isMembershipOnboarding) return AppPathEnum.MEMBERSHIP_ONBOARDING;
}

export function getRouteAccess(path: AppPathEnum, user: CurrentUser, allowedRoles?: readonly string[]): { allowed: boolean; redirect?: AppPathEnum } {

    if (!user.account || !user.hasRoleClaim)
        return { allowed: false };

    if (path === AppPathEnum.MEMBERSHIP_RENEWAL) {
        const redirect = getMembershipRedirect(user);
        if (redirect) return { allowed: false, redirect };
    }

    if (path === AppPathEnum.MEMBERSHIP_ONBOARDING && !user.isMembershipOnboarding)
        return { allowed: false };

    if (path === AppPathEnum.REQUEST || (path === AppPathEnum.MEMBERSHIP_TRANSFER && user.roles.length === 0)) {
        return { allowed: true };
    }

    if (allowedRoles?.filter(role => role === '').length === 1) {
        return { allowed: true };
    }

    return { allowed: user.roles.some(role => allowedRoles?.includes(role)) };
}
